import React from 'react';

const styles = require('./PopupButtonBar.less');

export const PopupButtonBar: React.FC = (props) => {
    return <div className={styles.popupButtonBar}>{props.children}</div>;
};
